import React, { useRef } from 'react'
import { laurelsWon, laurelsSelected } from '../data/record'

// One row, scrolled sideways, with arrows that actually work.
//
// The earlier version hid the scrollbar and gave no controls, which on a
// desktop with a mouse meant it could not be scrolled at all. Five visible on
// desktop, three on a phone, tight gaps, so each laurel is large enough to
// read the festival name. That was the whole point of showing them.
//
// Every PNG is trimmed and scaled to a constant ink area, but the canvases are
// NOT identical: they run 340x340, 360x234, 360x288, 360x315, 360x326. The
// images therefore carried width='360' height='165' attributes that were wrong
// for every single one, so the browser reserved the wrong box and the row
// jumped sideways when each PNG landed. Lighthouse reported this as an unsized
// image element.
//
// The attributes are gone and the slot is fixed in CSS instead: .laurel-row li
// is a set box and the image is object-fit: contain inside it. Nothing moves,
// whatever shape the PNG turns out to be. If the laurels are ever re-exported
// to one common canvas, the attributes can come back.

const laurels = [...laurelsWon, ...laurelsSelected]

const LaurelScroller = () => {
  const rail = useRef(null)

  const nudge = (dir) => {
    const el = rail.current
    if (!el) return
    el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: 'smooth' })
  }

  return (
    <div className='laurel-strip'>
      <div className='laurel-shell'>
        <button className='laurel-arrow laurel-arrow--prev' onClick={() => nudge(-1)} aria-label='Previous laurels'>
          <svg viewBox='0 0 24 24' aria-hidden='true'>
            <polyline points='15,4 7,12 15,20' fill='none' stroke='currentColor' strokeWidth='1.5' />
          </svg>
        </button>

        <ul className='laurel-row' ref={rail}>
          {laurels.map((l) => (
            <li key={l.src}><img src={l.src} alt={l.alt} loading='lazy' decoding='async' /></li>
          ))}
        </ul>

        <button className='laurel-arrow laurel-arrow--next' onClick={() => nudge(1)} aria-label='More laurels'>
          <svg viewBox='0 0 24 24' aria-hidden='true'>
            <polyline points='9,4 17,12 9,20' fill='none' stroke='currentColor' strokeWidth='1.5' />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default LaurelScroller
